/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.0
 */
import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../reducers/rootReducer';
import { ISuperSearchReducerState as ISSstate } from './superSearchReducer';
import { ISuperSearch } from './superSearchTypes';

export const getSuperSearchState = (state: IRootReducer) => state.superSearch;

export const makeSelectSuperSearchEmpty = (): OutputSelector<
  IRootReducer,
  boolean,
  (state: ISSstate) => boolean
> =>
  createSelector(getSuperSearchState, (state: ISSstate) => {
    return state.emptyList;
  });
export const makeSelectSuperSearchError = (): OutputSelector<
  IRootReducer,
  string,
  (state: ISSstate) => string
> =>
  createSelector(getSuperSearchState, (state: ISSstate) => {
    return state.message;
  });
export const makeSelectSuperSearchIsOpen = (): OutputSelector<
  IRootReducer,
  boolean,
  (state: ISSstate) => boolean
> =>
  createSelector(getSuperSearchState, (state: ISSstate) => {
    return state.isOpen;
  });
export const makeSelectSuperSearchIsSearch = (): OutputSelector<
  IRootReducer,
  boolean,
  (state: ISSstate) => boolean
> =>
  createSelector(getSuperSearchState, (state: ISSstate) => {
    return state.isSearch;
  });
export const makeSelectSuperSearchResponse = (): OutputSelector<
  IRootReducer,
  ISuperSearch,
  (state: ISSstate) => ISuperSearch
> =>
  createSelector(getSuperSearchState, (state: ISSstate) => {
    return state.searchReponse;
  });
export const makeSelectSuperSearchValue = (): OutputSelector<
  IRootReducer,
  string,
  (state: ISSstate) => string
> =>
  createSelector(getSuperSearchState, (state: ISSstate) => {
    return state.searchValue;
  });
